<template>
  <div class="bm-home">
    <div class="wrap" v-if="isShowMine()">
      <div class="my-state">
        <cube-tip ref="tip" direction="top" class="tip-pos">当日购买保障会在次日获取保障状态<br>不用担心哦！</cube-tip>
        <div v-if="!isShowInsureData">
          <span>斑马邦意外险让运动更有保障！</span>
        </div>
        <div v-else>
          <div v-if="!!insuranceInfo">
            <div class="name">
              <span v-text="getSimpleName(insuranceInfo && insuranceInfo.productName)"></span>
              <!-- <i class="cubeic-question question" @click="showTip"></i> -->
            </div>
            <div class="progress" @click="goEntryPage('insure')">
              <span v-if="insuranceInfo.alreadyDays>0"><span>已保障<span class="size" v-text="insuranceInfo && insuranceInfo.alreadyDays"></span>天</span></span>
              <span v-else><span>待生效</span></span>
              <i class="cubeic-arrow"></i>
            </div>
          </div>
          <div v-else>
            <span>您还没有运动保障哦</span>
            <i class="cubeic-question question" @click="showTip"></i>
          </div>
        </div>
      </div>
      <div class="my-desc clearfix">
        <div v-if="!isShowInsureData">
          <div class="msg">
            <div class="text">有人给你买保障了？</div>
            <div class="text">认证个人信息获取保障</div>
          </div>
          <div class="real">
            <button class="btn" @click="getCert()">立即认证</button>
          </div>
        </div>
        <div v-else>
          <div v-text="certificationInfo && certificationInfo.BindTo"></div>
        </div>
      </div>
      <div class="my-links" v-if="isInApp">
        <span class="link" @click="goEntryPage('query')">查询保单</span><span class="link" @click="goEntryPage('pay')">理赔服务</span><span class="link" @click="goEntryPage('insure')">我的保单</span>
      </div>
    </div>
    <div class="wrap space">
      <div class="hidden-box">
        <cube-slide class="slide" :data="bannerList"/>
      </div>
    </div>
    <div class="wrap" id="product">
      <div class="header">
        <span class="title">产品推荐</span>
        <span class="more" @click="goAllProducts">更多</span>
      </div>
      <div class="list">
        <div class="list-item" v-for="(item, index) in filterProductList" :key="index" @click="goInsureDetails(item.link, $event)">
          <div v-if="item.type == 1">
            <img class="img" src="@/assets/insure/p1.png">
            <div class="item-text">
              <div class="name" v-text="item.name"></div>
              <div class="desc" v-text="item.desc"></div>
              <div class="btn">立即预约</div>
            </div>
          </div>
          <div v-else>
            <img class="img" src="@/assets/insure/p2.png">
            <div class="item-text">
              <div class="name" v-text="item.name"></div>
              <div class="desc" v-text="item.desc"></div>
              <div class="price"><span class="unit">¥</span><span v-text="item.price"></span><span class="unit">起</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="list-more" @click.stop="toggleList()" v-bind:class="{active: isExtend}">
        <span>全部球类保障</span>
        <i class="cubeic-select"></i>
      </div>
    </div>
    <div class="wrap">
      <div class="note-box">
        <img class="note" src="@/assets/insure/note.png">
        <div class="note-txt">
          本平台（部分）产品为深圳市慧择保险经纪有限公司提供投保链接，
          相应保险经纪服务保全、理赔协助等由深圳市慧择保险经纪有限公司提供
        </div>
      </div>
    </div>
    <div class="wrap space padding-reset">
      <div class="header indent">
        <span class="title">服务案例</span>
      </div>
      <div class="horizontal-scroll-list-wrap">
        <cube-scroll ref="scroll" direction="horizontal">
          <ul class="list-wrapper">
            <li class="list-item" v-for="(item, index) in caseList" :key="index" @click="goCaseDetails(item.subjectId)">
              <img class="thumb" v-bind:src="imageView(item.poster, 279*2, 157*2)">
              <div class="title" v-text="item.title"></div>
              <div class="date" v-text="item.publishDate"></div>
            </li>
          </ul>
        </cube-scroll>
        </div>
        <div class="entry-links" v-if="!isInApp">
          <div class="item" @click="goEntryPage('query')">查询保单</div>
          <div class="item" @click="goEntryPage('pay')">理赔服务</div>
          <div class="item" @click="goEntryPage('insure')">我的保单</div>
        </div>
    </div>
  </div>
</template>

<script>
// import * as moment from 'moment'
import { getInsureHomePage } from '@/api/insure'
import { ImageFormat, AppType } from '@/utils'
import { getUserInfo } from '@/libs/cookie-storage'
import { getUserInfoFromNative } from '@/libs/passport'

export default {
  name: 'Home',
  data () {
    return {
      productList: [],
      bannerList: [],
      caseList: [],
      isShowInsureData: false,
      certificationInfo: null,
      insuranceInfo: null,
      isExtend: false,
      isInApp: AppType.isInApp(),
      user: getUserInfo()
    }
  },
  created() {
  },
  computed: {
    filterProductList: function () {
      if (this.isExtend) {
        return this.productList
      } else {
        return this.productList.slice(0, 4)
      }
    }
  },
  watch: {
    productList: {
      handler: function() {
        this.$nextTick(function() {
          const query = this.$route.query
          if (query && query.anchor === 'product') {
            this.goAnchorElement()
          }
        })
      },
      deep: true
    }
  },
  mounted () {
    const self = this
    this.wxShare({
      title: '斑马邦球类意外保障，让运动更安心！',
      link: window.location.href,
      image: this.imageView('Ftvh0Xzx9Jba83hwBIzI3kQnd-bx', 120, 120),
      abstract: '微小的投入，换来的是更多的安心，斑马邦在球场为你撑起保护伞'
    })
    getUserInfoFromNative().then(function(res) {
      self.fetchData()
      self.user = getUserInfo()
    })
    this.trackingTD('page_insure')
  },
  methods: {
    reload() {
      location.reload()
    },
    goEntryPage(type) {
      if (event && event._constructed) return
      if (type === 'query') {
        location.href = 'https://travelcpsh5.qixin18.com/czh1007574/policy/search'
      } else if (type === 'pay') {
        location.href = 'http://www.bxy18.com/index'
      } else if (type === 'insure') {
        this.$router.push({name: 'InsureList'})
      }
    },
    getCert() {
      this.$router.push({name: 'InsureList'})
    },
    fetchData() {
      getInsureHomePage().then(response => {
        const result = response.data
        const banner = result.banner
        for (let i = 0; i < banner.length; i++) {
          let obj = {
            url: banner[i].url,
            image: ImageFormat.imageView(banner[i].poster, 690, 132)
          }
          this.bannerList.push(obj)
        }
        this.caseList = result.cases
        this.productList = [
          {name: '团购 - 球类意外保障', desc: '多人赛事意外保障首选', price: '', link: 'booking', type: 1},
          {name: '日计划 - 球类意外保障', desc: '3-60周岁 不含猝死', price: '1.00', link: 'https://cps.qixin18.com/m/czh1007574/product/detail-100527-101029.html', type: 2},
          {name: '月计划 - 球类意外保障', desc: '3-60周岁', price: '10.00', link: 'https://cps.qixin18.com/m/czh1007574/product/detail-100526-101028.html', type: 2},
          {name: '年计划 - 球类意外保障', desc: '3-60周岁 含猝死', price: '107.00', link: 'https://cps.qixin18.com/m/czh1007574/product/detail-100530-101032.html', type: 2},
          {name: '日计划 - 球类意外保障', desc: '3-60周岁 含猝死', price: '2.00', link: 'https://cps.qixin18.com/m/czh1007574/product/detail-100528-101030.html', type: 2},
          {name: '年计划 - 球类意外保障', desc: '3-60周岁 不含猝死', price: '95.00', link: 'https://cps.qixin18.com/m/czh1007574/product/detail-100529-101031.html', type: 2},
          {name: '综合 — 户外综合赛事保险', desc: '3-85周岁', price: '8.00', link: 'https://cps.qixin18.com/m/czh1007574/product/detail-100204-100381.html', type: 2}
        ]
        this.isShowInsureData = !!result.myInsuranceProfile
        if (this.isShowInsureData) {
          this.insuranceInfo = result.myInsuranceProfile.insuranceInfo
          this.certificationInfo = result.myInsuranceProfile.certificationInfo
        }
      })
    },
    goCaseDetails(subjectId) {
      location.href = process.env.SITE_URL + '/index.html?redirect=post-detail&id=' + subjectId
    },
    goInsureDetails(link, event) {
      // var e = arguments.callee.caller.arguments[0] || window.event;
      if (event && event._constructed) return
      if (link === 'booking') {
        link = process.env.SITE_URL + '/index.html?redirect=subscribe-form&type=insurance'
      }
      location.href = link
      this.trackingTD('scene_insure_product_detail')
    },
    toggleList() {
      this.isExtend = !this.isExtend
    },
    isShowMine() {
      return AppType.isInApp() || (this.user && this.user.hasCertificate === 1)
    },
    isOnWork() {
      // const startDate = this.insuranceInfo && this.insuranceInfo.currentOrderSummary.startDate
      // return moment(startDate) - moment() < 0
      return this.insuranceInfo && this.insuranceInfo.alreadyDays > 0
    },
    showTip(event) {
      const target = event.target
      let clientX = target.offsetWidth + target.offsetLeft
      const clientY = target.offsetHeight + target.offsetTop
      const selectDom = document.querySelector('.bm-home .tip-pos')
      const angleDom = document.querySelector('.bm-home .tip-pos .cube-tip-angle')
      if (clientX < 238 / 2) {
        selectDom.style.left = 0
        angleDom.style.left = (clientX - 8) + 'px'
      } else if (clientX + 238 / 2 > document.body.offsetWidth) {
        angleDom.style.left = ((238) - (document.body.offsetWidth - clientX)) + 'px'
        selectDom.style.left = (document.body.offsetWidth - 238 - 8) + 'px'
      } else {
        selectDom.style.left = (clientX - 238 / 2 - 8) + 'px'
      }
      selectDom.style.top = (clientY + 6) + 'px'
      this.$refs.tip.show()
    },
    goAllProducts() {
      location.href = 'https://cps.qixin18.com/m/czh1007574/product/typelist'
    },
    goAnchorElement() {
      const anchorElement = document.getElementById('product')
      anchorElement.scrollIntoView()
    },
    getSimpleName(name) {
      return name && name.split('（')[0]
    },
    imageView(hash, w, h, mode, format) {
      return ImageFormat.imageView(hash, w, h, mode, format)
    }
  }
}
</script>

<style lang="stylus">
.bm-home
  .wrap
    padding 20px 30px
    color #4c4c4c
    font-weight 400
    background-color #fff
    .note-box
      display: flex;
      align-items: flex-start;
      .note
        width 130px
        flex: 0 0 auto
        border-radius:4px
      .note-txt
        color #9b9b9b
        flex: 1 1 auto;
        padding-left 30px
        line-height 1.5
        padding-top 12px
    .question
      color #369ad4
      font-size 36px; /*px*/
    .tip-pos
      padding-right 60px
      text-align center
    .my-state
      font-size 48px
      padding 20px 0
      height 66px
      line-height 66px
      .name
        float left
        max-width: 70%;
      .progress
        font-size 32px; /*px*/
        color #3b3b3b
        float right
        .size
          font-size 48px; /*px*/
    .my-desc
      font-size 36px; /*px*/
      padding: 20px 0 40px 0
      .msg
        float left
        font-size 28px; /*px*/
        color #9b9b9b
        .text
          line-height 40px
      .real
        float right
        .btn
          font-size 28px;  /*px*/
          color #EC4E4E
          padding 10px 30px
          border 1px solid #EC4E4E; /*no*/
          background #FFF
          border-radius 34px
    .my-links
      display -webkit-box
      display box
      width 100%
      padding 30px 0
      border-top: 1px solid #e3e3e3; /*no*/
      .link
        flex 1
        font-size 32px; /*px*/
        color #4a4a4a
        text-align center
        display block
        border-right 1px solid #e3e3e3; /*no*/
        &:last-child
          border-right none
    .header
      padding 12px 0 30px 0
      font-size 36px; /*px*/
      &.indent
        padding-left 30px
      .more
        font-size 28px; /*px*/
        color #9b9b9b
        float: right
        line-height 42px
    .list
      .list-item
        color white
        margin-bottom 40px
        height 224px
        overflow hidden
        position relative
        .img
          height 224px
          border none
        .item-text
          position absolute
          top 0
          padding-left 30px
          .name
            font-size 40px; /*px*/
            padding-top 30px
          .desc
            font-size 24px; /*px*/
            padding 28px 0
          .btn
            font-size 28px;  /*px*/
            padding 8px 22px
            border 1px solid #fff; /*no*/
            border-radius 4px
            display inline-block
          .price
            font-size 52px;  /*px*/
            padding 8px 0 22px 0
            .unit
              font-size 24px;  /*px*/
    .list-more
      height 100px
      background-color: #fff;
      text-align: center;
      font-size: 28px; /*px*/
      color: #4c4c4c;
      line-height: 100px;
      border-top: 1px solid #f8f8f8; /*no*/
    .hidden-box
      overflow hidden
      .slide
        height: 132px
    .cube-scroll-content
      display: inline-block
      .list-wrapper
        padding: 0
        white-space: nowrap
        height 450px
        .list-item
          display: inline-block
          padding-left 30px
          padding-bottom 30px
          .thumb
            border none
            height 314px
            width 558px
          .title
            font-size 32px;  /*px*/
            padding 20px 0
          .date
            font-size 28px;  /*px*/
            color #9b9b9b
            line-height 30px
  .space
    margin 20px 0
  .padding-reset
    padding-left 0
    padding-right 0
    margin-bottom 110px
  .entry-links
    position fixed
    bottom 0
    height 64px
    background-color #fff
    color #4a4a4a
    font-size 32px
    width 100%
    max-width 960px; /*px*/
    line-height 64px
    z-index 1
    display -webkit-box
    display box
    border-top 1px solid #e3e3e3; /*no*/
    padding 30px 0
    .item
      flex 1
      text-align center
      border-right 1px solid #e3e3e3; /*no*/
      &:last-child
        border-right none

.bm-home
  .list-more
    &.active
      .cubeic-select::before
        display: inline-block;
        transform: rotate(180deg);
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue